/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class WeatherRequest {
    'temperature'?: number;
    'windSpeed'?: number;
    'humidity'?: number;
    'cloud'?: number;
    'windFromDirection'?: number;
    'precipitationAmount'?: number;
    'probabilityOfPrecipitation'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "temperature",
            "baseName": "temperature",
            "type": "number",
            "format": "double"
        },
        {
            "name": "windSpeed",
            "baseName": "windSpeed",
            "type": "number",
            "format": "double"
        },
        {
            "name": "humidity",
            "baseName": "humidity",
            "type": "number",
            "format": "double"
        },
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "number",
            "format": "double"
        },
        {
            "name": "windFromDirection",
            "baseName": "windFromDirection",
            "type": "number",
            "format": "double"
        },
        {
            "name": "precipitationAmount",
            "baseName": "precipitationAmount",
            "type": "number",
            "format": "double"
        },
        {
            "name": "probabilityOfPrecipitation",
            "baseName": "probabilityOfPrecipitation",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return WeatherRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

